// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c724e772","45":"17497306","93":"0c44fde4","246":"61ec1514","348":"2a6c3e2c","440":"bfca3ad4","506":"7c5cd5be","534":"56cf3b8b","717":"e84a7fb6"}[chunkId] + ".chunk.js";
};